import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import img from "./imgs/logo_white.png";
import { FaBars, FaHome, FaCouch, FaSignOutAlt, FaClipboardList} from "react-icons/fa";
import "./SideBar.css";
import { ROLES } from "../constants/roles";

function SideBar() {
  const [isOpen, setIsOpen] = useState(false);
  const sidebarRef = useRef(null);

  const toggleSidebar = () => setIsOpen(!isOpen);

  const onLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  }

   // إغلاق القائمة عند الضغط خارجها
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !event.target.closest(".menu-toggle")
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  // put json.parse in try catch to avoid crash if user data is corrupted
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    console.error("Error parsing user data:", e);
  }

  return (
    <>
      <button className="menu-toggle" onClick={toggleSidebar}>
        <FaBars />
      </button>

      <aside className={`sidebar ${isOpen ? "open" : ""}`}>
        <div className="logo">
          <img src={img} alt="logo" />
        </div>

        <div className="sideLinks">
          {user?.role !== ROLES.FACTORY && (
          <Link to="/">
            <FaHome style={{paddingLeft:"10px",marginBottom:"-3px"}}/> الصفحة الرئيسية
          </Link>
          )}
          <Link to="/orders">
            <FaClipboardList style={{paddingLeft:"10px",marginBottom:"-3px"}}/> الطلبات
          </Link>
          {user?.role !== ROLES.FACTORY && (
          <Link to="/add-Order">
            <FaCouch style={{paddingLeft:"10px",marginBottom:"-3px"}}/> إضافة طلب
          </Link>
        )}
        </div>

        <div className="log">
          <Link to="/login" onClick={onLogout}>
            <FaSignOutAlt style={{paddingLeft:"10px",marginBottom:"-3px"}}/> تسجيل الخروج
          </Link>
        </div>
      </aside>
    </>
  );
}

export default SideBar;
